import React from "react";
import PropTypes from "prop-types";
import {
  Avatar,
  Divider,
  Tooltip,
  CardActions,
  Typography,
  Icon,
  ListItem,
  ListItemAvatar,
  Button,
  Box,
  Fab,
  ButtonBase,
  Paper,
  Grid,
  IconButton,
} from "@material-ui/core";
import { DeleteForever } from "@material-ui/icons";
import SignalWifiOffIcon from "@material-ui/icons/PermIdentity";

import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { USER_ROLE } from "../../components/security/UserRole";
import { history } from "../../components/helpers/History";
import DoctorImg from "../../img/doctor.png";
import AppointmentCancelConfirmation from './AppointmentCancelConfirmation';
import AppointmentQrCode from './AppointmentQrCode';
import AppointmentModificationConfirmation from './AppointmentModificationConfirmation';
import AppointmentSendMessage from './AppointmentSendMessage';
import moment from "moment";



const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
  },
  paper: {
    padding: theme.spacing(2),
    margin: "auto",
    maxWidth: "100%",
  },
  image: {
    width: 128,
    height: 128,
  },
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  buttons: {},
  button: {
    marginRight: theme.spacing(2),
    textTransform: "none",
    color: "#FFF",
    borderRadius: 10,
    border: 0,
    boxShadow: "0 0px 0px 0px rgba(0, 0, 0, 0)",
  },
  edit: {
    color: "#3b5998",
    margin: theme.spacing(1),
  },
  confirmButton: {
    color: "#3788d8",
    margin: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  
}));

const AppointmentHistoryCardView = (props) => {
  const appointment = props.appointment;
  const handleEditAppointment = props.handleEditAppointment;
  const showEditAppointment = props.showEditAppointment;
  const classes = useStyles();
  const user = useSelector((state) => state.authentication.user);
  const userRole = user.userRole ? user.userRole : "";
  function handleCancelAppointment(id) {
    props.handleCancelAppointment(id);
  }

  function handleConfirmAppointment(id) {
    props.handleConfirmAppointment(id);
  }

  function handleQRCodeScaner(id) {
    history.push("/qrcode/" + id);
  }
  function splitDateAndTime(date) {
    return date.replace("T", " ");
  }

  return (
    <>
      <Box clone m={1} borderRadius={4} boxShadow={3}>
        <Paper elevation={3}>
          <Box
            display="flex"
            pt={1}
            pl={2}
            pr={2}
            fontWeight="fontWeightMedium"
            fontSize={13}
          >
            <Box flexGrow={1}>
              <Box display="flex" color="primary.main">
                <Box>
                  <i className="ri-calendar-fill"></i>
                </Box>
                
                <Box pl={1}>{appointment && appointment.startDateTime && moment(appointment.startDateTime).format("YYYY-MM-DD hh:mm a")}</Box>
                <Box pl={1}>{' To '}</Box>
                <Box pl={1}>{appointment && appointment.endDateTime && moment(appointment.endDateTime).format("YYYY-MM-DD hh:mm a")}</Box>
              </Box>
            </Box>
            <Box>{appointment.status}</Box>
          </Box>
          <Box m={2}>
            <Grid container spacing={3} alignItems="center" wrap="nowrap">
              <Grid item>
                <Box clone>
                  <Avatar variant="circle">
                  {userRole === USER_ROLE.PATIENT ? (
                    <img
                      className={classes.img}
                      alt="complex"
                      src={DoctorImg}
                    />):null}
                  {userRole === USER_ROLE.DOCTOR ? (
                    null):null}
                  {userRole !== USER_ROLE.DOCTOR && userRole !== USER_ROLE.PATIENT ? (
                    <img
                      className={classes.img}
                      alt="Patient"
                      src={DoctorImg}
                    />):null}
                  </Avatar>
                </Box>
              </Grid>
              <Grid item>
                {appointment.doctorDetails && userRole !== USER_ROLE.DOCTOR ? (
                  <Box display="flex" color="primary.main">
                    <Box>
                    <i className="fas fa-stethoscope"></i>
                    </Box>
                    <Box pl={1}>{appointment.doctorDetails.firstName +
                        " " +
                        appointment.doctorDetails.lastName}</Box>
                  </Box>
                ) : null}
                {appointment.patientDetails &&
                userRole !== USER_ROLE.PATIENT ? (
                  <Box display="flex" color="primary.main">
                    <Box>
                    <i className="fas fa-user-injured"></i>
                    </Box>
                    <Box pl={1}>{appointment.patientDetails.firstName +
                      " " +
                      appointment.patientDetails.lastName}</Box>
                  </Box>) : null}
                <Divider
                      className={classes.divider}
                      orientation="horizontal"
                    />
                <Typography gutterBottom variant="body3" color="textSecondary">
                  {appointment.consultationType}
                </Typography>
              </Grid>
              <Grid item>
                <Box overflow="hidden">
                  <Typography variant="body2" color="textSecondary">
                    {appointment.description ? appointment.description.substring(0, 100):''}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            <Grid container justify="flex-end" spacing={1}>
              {showEditAppointment ? (
                <Grid item className={classes.buttons}>
                  {appointment.status &&
                  appointment.status !=="CANCELED" ? (
                    
                    <Grid item container direction="row">
                      <Grid item>
                        {/* <div
                          variant="rounded"
                          className={classes.edit}
                          onClick={() => {
                            handleEditAppointment(appointment.id);
                          }}
                        >
                          <i className="fas fa-pen"></i>
                        </div> */}
                        {appointment.status !=="BLOCKED"?
                          <AppointmentModificationConfirmation id={appointment.id} handleModification={handleEditAppointment}></AppointmentModificationConfirmation>
                          : null}
                      </Grid>
                      <Grid item>
                        {/* <div
                          variant="rounded"
                          className={classes.cancelButton}
                          onClick={() => {
                            handleCancelAppointment(appointment.id);
                          }}
                        >
                          <i className="fas fa-trash-alt"></i>
                        </div> */}
                        <AppointmentCancelConfirmation id={appointment.id} handleCancelAppointment={handleCancelAppointment}></AppointmentCancelConfirmation>
                      </Grid>
                      
                      {userRole === USER_ROLE.PATIENT ? (
                        <Grid item>
                          <AppointmentQrCode id={appointment.id} ></AppointmentQrCode>
                        </Grid>
                      ) : null}


                      {userRole !== USER_ROLE.PATIENT &&
                        appointment.status &&
                      (appointment.status.indexOf("BOOKED") === 0 ||
                        appointment.status.indexOf("RESCHEDULED") === 0) &&
                        <Grid item>
                          <AppointmentSendMessage id={appointment.patientId} ></AppointmentSendMessage>
                        </Grid>
                        
                        }
                      
                      {userRole !== USER_ROLE.PATIENT &&
                      appointment.status &&
                      (appointment.status.indexOf("BOOKED") === 0 ||
                        appointment.status.indexOf("RESCHEDULED") === 0) ? (
                        <Grid item>
                          <Tooltip title="Confirm appointment" arrow>
                            <div
                              variant="rounded"
                              className={classes.confirmButton}
                              onClick={() => {
                                handleConfirmAppointment(appointment.id);
                              }}
                            >
                              <i className="fas fa-calendar-check"/>
                            </div>
                          </Tooltip>
                        </Grid>
                      ) : null}
                    </Grid>
                  ) : (
                    <Grid item container direction="column" spacing={1}></Grid>
                  )}
                </Grid>
              ) : (
                <Grid item container direction="row" spacing={1}>
                  &nbsp;
                </Grid>
              )}
            </Grid>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

AppointmentHistoryCardView.propTypes = {
  appointment: PropTypes.object.isRequired,
  showBookNowBtn: PropTypes.bool.isRequired,
};

export default AppointmentHistoryCardView;
